<template>
  <pt-consulting-subscribe-order class="pt-consulting-subscribe-order__withData"></pt-consulting-subscribe-order>
</template>

<script>
import PtConsultingSubscribeOrder from './index'
export default {
  name: 'pt-consulting-subscribe-order__withData',
  components: {
    'pt-consulting-subscribe-order': PtConsultingSubscribeOrder
  }
}
</script>
